export const PASSWORD_RESET_ACTION_LABEL = "SEND PASSWORD RESET LINK";

export const hasPasswordProvider = (
  providerData: readonly { providerId: string }[] | null | undefined,
) => providerData?.some(({ providerId }) => providerId === "password") ?? false;
